import { routes } from '../navigation/routes'

export const getPathname = (screen) => {
  const pathname = routes.find((element) => element.uniqueName === screen)
  const pathSplit = pathname.path.split('/')
  return pathSplit[pathSplit.length - 1]
}
